import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[appCopy]',
  standalone: true
})
export class AppCopyDirective implements OnInit {
  target: HTMLElement;
  originalHtml?: string;

  copyMarker = this.createCopyMarker();
  successMarker = this.createSuccessMarker();

  constructor(private element: ElementRef) {
    this.target = this.element.nativeElement as HTMLElement;
  }

  ngOnInit() {
    if (!this.originalHtml) {
      this.originalHtml = this.target.innerHTML;
    }

    const iconsWrapper = document.createElement('div');

    iconsWrapper.classList.add('copy-icons-wrapper');
    iconsWrapper.appendChild(this.copyMarker);
    iconsWrapper.appendChild(this.successMarker);

    this.target.appendChild(iconsWrapper);
  }

  @HostListener('click', ['$event'])
  async onClick($event) {
    const target = $event.target as HTMLElement;
    if (target && target.classList.contains('fa-copy'))
      await this.copyToClipboard();
  }

  async copyToClipboard() {
    const copy = this.getCopy();

    if (copy) {
      await navigator.clipboard.writeText(copy);
      this.showCopyMarker();
    }
  }

  getCopy(): string {
    const copy = this.target.textContent?.trim();

    if (copy && copy.length != 0 && copy != '-') {
      return copy;
    }

    return '';
  }

  showCopyMarker() {
    this.successMarker.style.display = this.getDisplay(false);
    this.copyMarker.style.display = this.getDisplay(true);

    setTimeout(() => {
      this.successMarker.style.display = this.getDisplay(true);
      this.copyMarker.style.display = this.getDisplay(false);
    }, 500);
  }

  createCopyMarker(hidden = false): HTMLElement {
    const copyMarker = document.createElement('i');

    copyMarker.className = 'fad fa-copy';
    copyMarker.style.display = this.getDisplay(hidden);

    return copyMarker;
  }

  createSuccessMarker(hidden = true): HTMLElement {
    const successMarker = document.createElement('i');

    successMarker.className = 'fa fa-check success-marker copy-marker';
    successMarker.style.display = this.getDisplay(hidden);

    return successMarker;
  }

  getDisplay(hidden = true): 'none' | 'inline-block' {
    return hidden
      ? 'none'
      : 'inline-block';
  }
}
